import { Row, Col, Form } from "react-bootstrap";
import {
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
  useRef,
} from "react";
import { handleHeaderOnlyAdd, handleStatusChange } from "./WPSObjects/WPSDataService";
import { useLocation } from "react-router-dom";
import { isAllowCustomSpecialCharacters, isSpecialCharactersNotes } from "../../functions/validations";
import { validateForm, handleChangeNotes } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import axios from "axios";
import { getPresignedURL } from "../../Services/Welder-services";
import defaultimg from "../../icons/noimage.png";
import { AddLogs } from "../../Services/wps-logs-services";
import { General_Single_Input_select, SingleInput, SingleInputTextAreaNotesWPS } from "../utility/forms/inputs/InputsTransaction"
import { getAllUserMaster } from "../../Services/user-service";
import { MessageTypes, Action, Status } from "../utility/common/constants/CommonConstants";
import { DisableFields, initializeErrorState, handleGeneralSubmit, handleGeneralSubmitTemp } from "./WPSObjects/WPSCommonUtils";

import {
  WPSH_PWHeatTre_Type,
  WPSH_Tech_BackGougingMethod,
  WPSPage1,
  WPSPage1_Overlay,
  WPS_Groove_Detail,
  WPS_Overlay_Detail,
  WPSPage2,
  WPSPage3_Groove,
  WPSPage3_Overlay,
  Wrap_insulation_material,
  Peening,
  Supplementary_mf_control,
  Thermal_process,
  Oscillation,
  Closed_to_out_chamber,
  WPSH_Initial_interpass_cleaning,
  WPSH_Tech_SurfacePreparation
} from "./WPSObjects/WPSGroove_entity";

import { WPSHeader } from "./WPSObjects/WPSHeader";
import { UnifiedSignatureSection } from "../utility/common/TransactionComponents/UnifiedSignatureSection";
import { todayDate } from "../utility/common/helpers/TodayDate";
import { DotLoader } from "react-spinners";
import { maxLength_WPSSpec } from "./WPSObjects/maxlength_WPS";
import { fetchImagePreview, ImageArray3, validateFile } from "../utility/common/TransactionComponents/CommonImages";
import { showWarning } from "../utility/ui/notifications/Toaster";

const WeldingProcedureSpec = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      tabno,
      setIsEditedPage3,
      setBtnDisabled,
      isReadonly,
      action
    },
    ref
  ) => {
    const location = useLocation();
    const Band = sessionStorage.getItem("Band");
    const folderwld = "wld_signatures";
    const folderwps = "WPS_Groove";
    const avatar = { defaultimg };
    const [WPStype] = useState(location.state?.WPStype);
    const [users, setUsers] = useState(null);
    const [IsEdited, setIsEdited] = useState(false);

    const [profile, setProfile] = useState("");
    const [profile1, setProfile1] = useState("");
    const [profile2, setProfile2] = useState("");
    const [previewUrl1, setPreviewUrl1] = useState();
    const [previewUrl2, setPreviewUrl2] = useState();
    const [previewUrl3, setPreviewUrl3] = useState();
    const [loading, setLoading] = useState(false);
    const [previewuser, setPreviewuser] = useState(avatar.defaultimg);
    const [previewapproved, setPreviewapproved] = useState(avatar.defaultimg);

    const fetchUserMaster = async () => {
      const result = await getAllUserMaster();
      const active = result.filter((item) => item.um_status == "Active");
      setUsers(active);
    };



    const GrooveFileMappings = [
      {

        setImage: setProfile,
        previewFn: previewUrl1,
        headerPath: () => headerObj.wld_pdf_image[0].Image1,
        imageKey: headerObj.wld_pdf_image[0].Image1,
        setPreviewFn: setPreviewUrl1,
        profile: profile
      },
      {
        setImage: setProfile1,
        previewFn: previewUrl2,
        headerPath: () => headerObj.wld_pdf_image[1].Image2,
        imageKey: headerObj.wld_pdf_image[1].Image2,
        setPreviewFn: setPreviewUrl2,
        profile: profile1
      },
      {
        setImage: setProfile2,
        previewFn: previewUrl3,
        headerPath: () => headerObj.wld_pdf_image[2].Image3,
        imageKey: headerObj.wld_pdf_image[2].Image3,
        setPreviewFn: setPreviewUrl3,
        profile: profile2
      },
    ]


    const handleChange = (e) => {

      if (action == Action.ActionEdit) setIsEdited(true);
      setIsEditedPage3(true);
      const { name, value } = e.target;

      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const [valueNotes, setValueNotes] = useState("");



    const handleChangeRadio = async (e) => {
      if (action == Action.ActionEdit) setIsEdited(true);
      if (!(await validate()) && !(await validate2(detaildata))) {
        const { name, value } = e.target;

        setheaderObj((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        showWarning("Cannot Approve or Reject the Record, Please Fill Required Fields of all 3 Pages.");
      }
    };

    const handleSelectChange = (e) => {
      if (action == Action.ActionEdit) setIsEdited(true);
      setIsEditedPage3(true);
      const { name, value } = e.target;
      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setError((prevState) => ({
        ...prevState,
        [name]: { status: false, message: "" },
      }));
    };

    const [error, setError] = useState(initializeErrorState('all'));

    const validate = async () => {
      const page1Fields = WPStype == "Groove" ? WPSPage1 : WPSPage1_Overlay;
      const page3Fields = WPStype == "Groove" ? WPSPage3_Groove : WPSPage3_Overlay;
      const detaildata = detailObj.filter((item) => item.WPSD_Process !== "");
      const errorConfig = WPStype == "Groove" ? WPS_Groove_Detail : WPS_Overlay_Detail;

      const validationResult = validateForm({
        headerObj,
        detailObj: detaildata,
        requiredFields: { ...page1Fields, ...page3Fields },
        detailConfig: errorConfig,
        currentErrors: error
      });

      setError(validationResult.errors);
      return validationResult.isError;
    };

    const validate2 = async (detaildata) => {
      const errorConfig = WPStype == "Groove" ? WPS_Groove_Detail : WPS_Overlay_Detail;

      const validationResult = validateForm({
        headerObj,
        detailObj: detaildata,
        requiredFields: WPSPage2,
        detailConfig: errorConfig,
        currentErrors: error
      });

      setError(validationResult.errors);
      return validationResult.isError;
    };




    const validateTemp = async () => {
      const isError = false;
      return { isError };
    };

    const handleAdd = async (approvalstatus) => {
      let previousStatus = headerObj.WPSH_Status;


      // Set approval status
      try {
        handleStatusChange(headerObj, location, action, approvalstatus);

        // Use common WPS data service for header-only add
        const result = await handleHeaderOnlyAdd(headerObj, location, approvalstatus);

        // Handle image uploads after successful header save
        if (result) {
          await handleImageUploads();

          // Add logs if needed
          if (
            action == Action.ActionEdit &&
            previousStatus == Status.StatusApproved
          ) {
            let logObj = {
              WPSH_Project_No_log:
                headerObj !== undefined ? headerObj.WPSH_Project_No : "",
              WPSH_WPS_No_log: headerObj !== undefined ? headerObj.WPSH_WPS_No : "",
              WPSH_User_Name_log: sessionStorage.getItem("UserName"),
              WPSH_User_Id_log: sessionStorage.getItem("UserId"),
              WPSH_Status_log: "",
            };
            await AddLogs(logObj);
          }
        }

        if (!result || result == MessageTypes.SpecialCharacters) {
          headerObj.WPSH_Status = previousStatus;
        }
        return result;
      } catch (error) {
        console.error("Error in handleAdd:", error);
        headerObj.WPSH_Status = previousStatus;
        return false;
      }
    };

    const handleImageUploads = async () => {
      try {
        for (const mapping of GrooveFileMappings) {
          const { profile, imageKey, setPreviewFn } = mapping;
          if (imageKey[0] != "" && imageKey[0] != undefined && profile != "") {
            const result = await getPresignedURL(folderwps, imageKey[0]);

            const posturl = result.url;
            setPreviewFn(posturl);
            await axios.put(posturl, profile);
          }
        }
      } catch (error) {
        console.error("Error uploading images:", error);
        throw error;
      }

    };


    const handleSubmitTemp = () => handleGeneralSubmitTemp(IsEdited,
      validateTemp,
      handleAdd,
      setLoading,
      setIsEdited,
      setIsEditedPage3);


    const detaildata = detailObj.filter((item) => item.WPSD_Process !== "");

    const handleSubmit = () => handleGeneralSubmit(validate, handleAdd, setLoading, setIsEditedPage3, Status.StatusPending);

    useImperativeHandle(ref, () => ({
      funcOnNext: async () => {
        let res = false;
        res = await handleSubmit();
        if (res == MessageTypes.Success) {
          setBtnDisabled(DisableFields(headerObj.WPSH_Status, headerObj.WPSH_Prepared_By, Status, Action, action) ? "disabled" : "");
        }
        return res;

      },

      funcOnNextTemp: async () => {
        let res = false;

        res = await handleSubmitTemp();

        return res;
      },
    }));

    const fetchImagestube = async (item, setPreviewFn) => {
      if (item) {
        const result = await getPresignedURL(folderwps, item);
        const posturl = result.url;
        setPreviewFn(posturl);

      }
    }

    useEffect(() => {

      GrooveFileMappings.forEach(({ imageKey, setPreviewFn, previewFn }) => {
        if (action === Action.ActionEdit || action === Action.ActionCopy) {
          if (imageKey[0] !== "" && imageKey[0] !== undefined && !previewFn) {
            fetchImagestube(imageKey[0], setPreviewFn);
          }
        }
      });
    }, [tabno, previewUrl1, previewUrl2, previewUrl3]);

    const handleFile1 = (file, index, e) => {
      if (validateFile(file)) {

        if (GrooveFileMappings[index]) {
          const { setPreviewFn, headerPath, setImage } = GrooveFileMappings[index];

          setPreviewFn(URL.createObjectURL(file));
          setImage(file)
          headerPath()[0] = file.name;
        }
      }
    };



    const fileInputRef = useRef(null);

    const fetchapproveUserProfile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewapproved,
        avatar.defaultimg
      );
    };

    const fetchbyuserprofile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewuser,
        avatar.defaultimg
      );
    };


    useEffect(() => {
      fetchUserMaster();
      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.wps_signaturePrepared !== "") {
        fetchbyuserprofile(headerObj?.wps_signaturePrepared);
      }
      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.wps_signatureApproved !== "") {
        fetchapproveUserProfile(headerObj?.wps_signatureApproved);
      }
    }, []);


    const groclass = WPStype === "Groove" ? "row-margin" : "d-none";
    const overclass = WPStype === "Overlay" ? "row-margin" : "d-none";

    const [grooveclass] = useState(groclass);
    const [overlayclass] = useState(overclass);

    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <WPSHeader headerObj={headerObj}></WPSHeader>
        <Row style={{ padding: "20px 60px" }}>
          <Row className="mb-2" style={{ position: "relative", left: "15px" }}>
            <span className="WPS-blue-text" style={{ position: "relative", right: "11px" }}>
              Joints (QW-402)
            </span>
            <div
              className="d-flex mb-4"
              style={{ position: "relative", right: "11px" }}
            >
              <div>
                <input
                  type="radio"
                  name="wld_Joints_Type"
                  value="Joint section"
                  checked={headerObj.wld_Joints_Type === "Joint section"}
                  disabled={isReadonly}
                  onChange={(e) => handleChange(e)}
                />
                <span className="ms-2">Joint section</span>
              </div>
              <div className="ms-5">
                <input
                  type="radio"
                  name="wld_Joints_Type"
                  value="Production drawing"
                  disabled={isReadonly}
                  checked={headerObj.wld_Joints_Type === "Production drawing"}
                  onChange={(e) => handleChange(e)}
                />
                <span className="ms-2">Production drawing</span>
              </div>
            </div>

            {headerObj.wld_Joints_Type === "Production drawing" ? (
              ""
            ) : (
              <>
                <ImageArray3

                  setPreviewUrl1={setPreviewUrl1}
                  setPreviewUrl2={setPreviewUrl2}
                  setPreviewUrl3={setPreviewUrl3}

                  previewUrl1={previewUrl1}
                  previewUrl2={previewUrl2}
                  previewUrl3={previewUrl3}
                  headerObj={headerObj}
                  setheaderObj={setheaderObj}
                  name="fileInput"
                  name1="fileInput1"
                  name2="fileInput2"
                  name3="fileInput3"
                  type="file"
                  accept="image/*"
                  fileInputRef={fileInputRef}
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  handleFile={handleFile1}

                ></ImageArray3>

                <Row className={`${grooveclass}` && "mb-1 mt-4"}>
                  <Col className={grooveclass} md={6}>
                    <SingleInput
                      name="WPSH_PHT_Root_spacing"
                      type="text"
                      maxLength={maxLength_WPSSpec.WPSH_PHT_Root_spacing}
                      status={error.WPSH_PHT_Root_spacing.status}
                      value={headerObj.WPSH_PHT_Root_spacing}
                      onChange={handleChange}
                      label="Root Spacing"
                      message={error.WPSH_PHT_Root_spacing.message}
                      error={error}
                      setError={setError}
                      disabled={isReadonly}
                    ></SingleInput>
                  </Col>
                </Row>
              </>
            )}
          </Row>
        </Row>

        <Row style={{ padding: "20px 60px" }} className="WPS-Page-row-padding">
          <Row className="mb-2" style={{ position: "relative", left: "15px" }}>
            <span
              className="WPS-blue-text"
              style={{ position: "relative", right: "11px" }}
            >
              Post Weld Heat Treatment (QW-407)
            </span>
            <Row className="mb-1">
              <Col className="mb-1" md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_Temperature"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Temperature}
                  status={error.WPSH_PWHeatTre_Temperature.status}
                  value={headerObj.WPSH_PWHeatTre_Temperature}
                  onChange={handleChange}

                  label="Post Weld H/T Temp(°C)"
                  message={error.WPSH_PWHeatTre_Temperature.message}
                  error={error}
                  setError={setError}
                  disabled={isReadonly}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="±+-"
                  customMessage="Special Characters # & % $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
              <Col className="mb-1" md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_Time"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Time}
                  status={error.WPSH_PWHeatTre_Time.status}
                  value={headerObj.WPSH_PWHeatTre_Time}
                  onChange={handleChange}
                  // label= "Post Weld Heat/Treatment Temperature (°C)"
                  label="Time (Minutes)"
                  message={error.WPSH_PWHeatTre_Time.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
              <Col className="mb-1" md={3}>
                <div class="T-input w-100">
                  <input
                    type="text"
                    id="WPSH_PWHeatTre_Heating_Rate"
                    name="WPSH_PWHeatTre_Heating_Rate"
                    maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Heating_Rate}
                    placeholder=" "
                    className={
                      error.WPSH_PWHeatTre_Heating_Rate.status
                        ? " T-input placeHolderInput inputText text-field-with-error"
                        : "T-input placeHolderInput inputText"
                    }
                    // value={ProjectObj.wld_ProjectNumber}
                    // onChange={handleChange}
                    value={headerObj.WPSH_PWHeatTre_Heating_Rate}
                    onChange={handleChange}
                    disabled={isReadonly}
                    error={error}
                    setError={setError}
                  />
                  <Form.Label htmlFor="WPSH_PWHeatTre_Heating_Rate">
                    Heating Rate (°C/Hr)
                  </Form.Label>
                </div>
                {headerObj.WPSH_PWHeatTre_Temperature !== "" ? (
                  <div className="required-text1">
                    {error.WPSH_PWHeatTre_Heating_Rate.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_PWHeatTre_Heating_Rate.message}
                      </Form.Text>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </Col>
              <Col className="mb-1" md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_Heating_Method"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Time}
                  status={error.WPSH_PWHeatTre_Heating_Method.status}
                  value={headerObj.WPSH_PWHeatTre_Heating_Method}
                  onChange={handleChange}
                  // label= "Post Weld Heat/Treatment Temperature (°C)"
                  label="Loading Temperature(°C)"
                  message={error.WPSH_PWHeatTre_Heating_Method.message}
                  disabled={isReadonly}
                  error={error}
                  setError={setError}
                ></SingleInput>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col className="mb-1" md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_Cooling_Rate"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Heating_Rate}
                  status={error.WPSH_PWHeatTre_Cooling_Rate.status}
                  value={headerObj.WPSH_PWHeatTre_Cooling_Rate}
                  disabled={isReadonly}
                  onChange={handleChange}
                  label=" Cooling Rate (°C/Hr)"
                  message={error.WPSH_PWHeatTre_Cooling_Rate.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="+&=±-"
                  customMessage="Special Characters # % $ ' < > ; not allowed"
                ></SingleInput>
              </Col>
              <Col md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_Cooling_Method"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Time}
                  disabled={isReadonly}
                  status={error.WPSH_PWHeatTre_Cooling_Method.status}
                  value={headerObj.WPSH_PWHeatTre_Cooling_Method}
                  onChange={handleChange}
                  label="UnLoading Temperature(°C)"
                  message={error.WPSH_PWHeatTre_Cooling_Method.message}
                  error={error}
                  setError={setError}
                ></SingleInput>
              </Col>
              <Col md={3}>
                <General_Single_Input_select
                  name="WPSH_PWHeatTre_Type"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_PWHeatTre_Type}
                  // status={error.WPSH_PWHeatTre_Type.status}
                  // message={error.WPSH_PWHeatTre_Type.message}
                  handleSelectChange={handleSelectChange}
                  label="Type"
                  array={WPSH_PWHeatTre_Type}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={12}>
                <SingleInput
                  name="WPSH_PWHeatTre_Notes"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Notes}
                  disabled={isReadonly}
                  status={error.WPSH_PWHeatTre_Notes.status}
                  value={headerObj.WPSH_PWHeatTre_Notes}
                  onChange={handleChange}
                  label="PWHT Notes"
                  message={error.WPSH_PWHeatTre_Notes.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="+&=±-"
                  customMessage="Special Characters # % $ ' < > ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_Post_Heat_temp"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Post_Heat_temp}
                  disabled={isReadonly}
                  status={error.WPSH_PWHeatTre_Post_Heat_temp.status}
                  value={headerObj.WPSH_PWHeatTre_Post_Heat_temp}
                  onChange={handleChange}
                  label="Post Heating Temp (°C)"
                  message={error.WPSH_PWHeatTre_Post_Heat_temp.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="±+-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
              <Col md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_Post_Heat_time"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Post_Heat_temp}
                  disabled={isReadonly}
                  status={error.WPSH_PWHeatTre_Post_Heat_time.status}
                  value={headerObj.WPSH_PWHeatTre_Post_Heat_time}
                  onChange={handleChange}
                  label="Post Heat Time (Minutes)"
                  message={error.WPSH_PWHeatTre_Post_Heat_time.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
              <Col md={3}>
                <General_Single_Input_select
                  name="WPSH_PWHeatTre_Wrap_insulation_material"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_PWHeatTre_Wrap_insulation_material}
                  status={error.WPSH_PWHeatTre_Wrap_insulation_material.status}
                  message={
                    error.WPSH_PWHeatTre_Wrap_insulation_material.message
                  }
                  handleSelectChange={handleSelectChange}
                  label="Wrap In Insulation Material"
                  array={Wrap_insulation_material}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_ISR_Temp"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_ISR_Temp}
                  disabled={isReadonly}
                  status={error.WPSH_PWHeatTre_ISR_Temp.status}
                  value={headerObj.WPSH_PWHeatTre_ISR_Temp}
                  onChange={handleChange}
                  label=" ISR Temperature (°C)"
                  message={error.WPSH_PWHeatTre_ISR_Temp.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="±+-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
              <Col md={3}>
                <SingleInput
                  name="WPSH_PWHeatTre_ISR_Time"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_ISR_Time}
                  disabled={isReadonly}
                  status={error.WPSH_PWHeatTre_ISR_Time.status}
                  value={headerObj.WPSH_PWHeatTre_ISR_Time}
                  onChange={handleChange}
                  label=" ISR Time (Minutes) "
                  message={error.WPSH_PWHeatTre_ISR_Time.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="±+-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
              <Col md={12}>
                <SingleInput
                  name="WPSH_PWHeatTre_Weld_Notes"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Notes}
                  disabled={isReadonly}
                  status={error.WPSH_PWHeatTre_Weld_Notes.status}
                  value={headerObj.WPSH_PWHeatTre_Weld_Notes}
                  onChange={handleChange}
                  label="ISR Notes"
                  message={error.WPSH_PWHeatTre_Weld_Notes.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="+&=±-"
                  customMessage="Special Characters # % $ ' < > ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
          </Row>
        </Row>

        {/*----------------------------- Field For Groove -------------------------------------------------------------------------------------*/}

        <Row className={grooveclass} style={{ padding: "20px 60px" }}>
          <Row className="mb-2" style={{ position: "relative", left: "15px" }}>
            <span
              className="WPS-blue-text"
              style={{ position: "relative", right: "11px" }}
            >
              Other Variables
            </span>
            <Row className="mb-1">

              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_BackGougingMethod"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_BackGougingMethod}
                  status={error.WPSH_Tech_BackGougingMethod.status}
                  message={error.WPSH_Tech_BackGougingMethod.message}
                  handleSelectChange={handleSelectChange}
                  label="Back Gouging Method"
                  array={WPSH_Tech_BackGougingMethod}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={6}>
                <SingleInput
                  name="WPSH_Tech_GroovePreparation"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_Tech_GroovePreparation}
                  disabled={isReadonly}
                  status={error.WPSH_Tech_GroovePreparation.status}
                  value={headerObj.WPSH_Tech_GroovePreparation}
                  onChange={handleChange}
                  label="Groove Preparation"
                  message={error.WPSH_Tech_GroovePreparation.message}
                  error={error}
                  setError={setError}
                ></SingleInput>
              </Col>
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_Inital_InterpassCleaning"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_Inital_InterpassCleaning}
                  status={error.WPSH_Tech_Inital_InterpassCleaning.status}
                  message={error.WPSH_Tech_Inital_InterpassCleaning.message}
                  handleSelectChange={handleSelectChange}
                  label="Initial/ Interpass Cleaning"
                  array={WPSH_Initial_interpass_cleaning}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_Peening"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_Peening}
                  status={error.WPSH_Tech_Peening.status}
                  message={error.WPSH_Tech_Peening.message}
                  handleSelectChange={handleSelectChange}
                  label="Peening"
                  array={Peening}
                ></General_Single_Input_select>
              </Col>

              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_SupplementaryMFControl"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_SupplementaryMFControl}
                  status={error.WPSH_Tech_SupplementaryMFControl.status}
                  message={error.WPSH_Tech_SupplementaryMFControl.message}
                  handleSelectChange={handleSelectChange}
                  label="Supplementary MF Control"
                  array={Supplementary_mf_control}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_SurfacePreparation"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_SurfacePreparation}
                  status={error.WPSH_Tech_SurfacePreparation.status}
                  message={error.WPSH_Tech_SurfacePreparation.message}
                  handleSelectChange={handleSelectChange}
                  label="Surface Preparation"
                  array={WPSH_Tech_SurfacePreparation}
                ></General_Single_Input_select>
              </Col>
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_UseOfThermalProcess"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_UseOfThermalProcess}
                  status={error.WPSH_Tech_UseOfThermalProcess.status}
                  message={error.WPSH_Tech_UseOfThermalProcess.message}
                  handleSelectChange={handleSelectChange}
                  label="Use of Thermal Process"
                  array={Thermal_process}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_Oscillation"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_Oscillation}
                  status={error.WPSH_Tech_Oscillation.status}
                  message={error.WPSH_Tech_Oscillation.message}
                  handleSelectChange={handleSelectChange}
                  label="Oscillation"
                  array={Oscillation}
                ></General_Single_Input_select>
              </Col>
              <Col md={6}>
                <SingleInput
                  name="WPSH_Tech_Change_Electrode_dia"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_Tech_Change_Electrode_dia}
                  disabled={isReadonly}
                  status={error.WPSH_Tech_Change_Electrode_dia.status}
                  value={headerObj.WPSH_Tech_Change_Electrode_dia}
                  onChange={handleChange}
                  label="Change in Electrode Diameter"
                  message={error.WPSH_Tech_Change_Electrode_dia.message}
                  error={error}
                  setError={setError}
                ></SingleInput>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_ClosedtooutChamber"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_ClosedtooutChamber}
                  status={error.WPSH_Tech_ClosedtooutChamber.status}
                  message={error.WPSH_Tech_ClosedtooutChamber.message}
                  handleSelectChange={handleSelectChange}
                  label="Closed to out Chamber"
                  array={Closed_to_out_chamber}
                ></General_Single_Input_select>
              </Col>
            </Row>
          </Row>
        </Row>

        {/*----------------------------- Field For Overlay -------------------------------------------------------------------------------------*/}

        <Row className={overlayclass} style={{ padding: "20px 60px" }}>
          <Row className="mb-2" style={{ position: "relative", left: "15px" }}>
            <span className="WPS-blue-text">Other Variables</span>
            <Row className="mb-1">
              <Col md={6}>
                <SingleInput
                  name="WPSH_Tech_Weld_deposit_chemistry"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_Tech_Weld_deposit_chemistry}
                  disabled={isReadonly}
                  status={error.WPSH_Tech_Weld_deposit_chemistry.status}
                  value={headerObj.WPSH_Tech_Weld_deposit_chemistry}
                  onChange={handleChange}
                  label="Weld Deposit Chemistry"
                  message={error.WPSH_Tech_Weld_deposit_chemistry.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="+&=%±-"
                  customMessage="Special Characters # $ ' < > ; not allowed"
                ></SingleInput>
              </Col>
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_Inital_InterpassCleaning"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_Inital_InterpassCleaning}
                  status={error.WPSH_Tech_Inital_InterpassCleaning.status}
                  message={error.WPSH_Tech_Inital_InterpassCleaning.message}
                  handleSelectChange={handleSelectChange}
                  label="Initial/ Interpass Cleaning"
                  array={WPSH_Initial_interpass_cleaning}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_SupplementaryMFControl"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_SupplementaryMFControl}
                  status={error.WPSH_Tech_SupplementaryMFControl.status}
                  message={error.WPSH_Tech_SupplementaryMFControl.message}
                  handleSelectChange={handleSelectChange}
                  label="Supplementary MF Control"
                  array={Supplementary_mf_control}
                ></General_Single_Input_select>
              </Col>
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_SurfacePreparation"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_SurfacePreparation}
                  status={error.WPSH_Tech_SurfacePreparation.status}
                  message={error.WPSH_Tech_SurfacePreparation.message}
                  handleSelectChange={handleSelectChange}
                  label="Surface Preparation"
                  array={WPSH_Tech_SurfacePreparation}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_Oscillation"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_Oscillation}
                  status={error.WPSH_Tech_Oscillation.status}
                  message={error.WPSH_Tech_Oscillation.message}
                  handleSelectChange={handleSelectChange}
                  label="Oscillation"
                  array={Oscillation}
                ></General_Single_Input_select>
              </Col>
              <Col md={6}>
                <General_Single_Input_select
                  name="WPSH_Tech_Peening"
                  readOnly={isReadonly}
                  disabled={isReadonly}
                  value={headerObj.WPSH_Tech_Peening}
                  status={error.WPSH_Tech_Peening.status}
                  message={error.WPSH_Tech_Peening.message}
                  handleSelectChange={handleSelectChange}
                  label="Peening"
                  array={Peening}
                ></General_Single_Input_select>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col className="mb-1" md={3}>
                <SingleInput
                  name="WPSH_Tech_Oscillation_Width"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Time}
                  disabled={isReadonly}
                  status={error.WPSH_Tech_Oscillation_Width.status}
                  value={headerObj.WPSH_Tech_Oscillation_Width}
                  onChange={handleChange}
                  label="Oscillation Width(mm)"
                  message={error.WPSH_Tech_Oscillation_Width.message}
                  error={error}
                  setError={setError}
                ></SingleInput>
              </Col>
              <Col className="mb-1" md={3}>
                <SingleInput
                  typeclass={overlayclass}
                  name="WPSH_Tech_Oscillation_Freq"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Time}
                  disabled={isReadonly}
                  status={error.WPSH_Tech_Oscillation_Freq.status}
                  value={headerObj.WPSH_Tech_Oscillation_Freq}
                  onChange={handleChange}
                  label="Oscillation Frequency in CPM"
                  message={error.WPSH_Tech_Oscillation_Freq.message}
                  setError={setError}
                  error={error}
                ></SingleInput>
              </Col>

              <Col className="mb-1" md={3}>
                <SingleInput
                  name="WPSH_Tech_Filler_Metal_Del"
                  type="text"
                  maxLength={maxLength_WPSSpec.WPSH_PWHeatTre_Time}
                  disabled={isReadonly}
                  status={error.WPSH_Tech_Filler_Metal_Del.status}
                  value={headerObj.WPSH_Tech_Filler_Metal_Del}
                  onChange={handleChange}
                  label="Filler Metal Delivery(GTAW)"
                  message={error.WPSH_Tech_Filler_Metal_Del.message}
                  error={error}
                  setError={setError}
                ></SingleInput>
              </Col>
            </Row>
          </Row>
        </Row>
        {/* -------------------------Notes--------------------------------*/}
        <Row style={{ padding: "20px 60px" }} className="WPS-Page-row-padding">
          <Row className="mb-2" style={{ position: "relative", left: "5px" }}>
            <span className="WPS-blue-text">
              Notes (Only the first six lines in the notes will appear in the WI Slip with a limit of 120 characters per line)
            </span>
            <Col md={12}>
              <SingleInputTextAreaNotesWPS
                name="WPSH_Notes"
                type="text"
                style={{ height: "250px", resize: "none" }}
                disabled={isReadonly}
                readOnly={isReadonly}
                maxLength={maxLength_WPSSpec.WPSH_Notes}
                className="textarea-notes"
                status={error.WPSH_Notes.status}
                // value={headerObj.WPSH_Notes}
                value={headerObj.WPSH_Notes ? headerObj.WPSH_Notes : valueNotes}
                handleChange={(e) => handleChangeNotes(e, setIsEdited, null, setIsEditedPage3, setheaderObj, setValueNotes)}
                // onKeyDown={handleKeyDown}
                label="Notes"
                message={error.WPSH_Notes.message}
                onInput={(e) => {
                  let error = isSpecialCharactersNotes(e.target.value);
                  setError((prevState) => ({
                    ...prevState,
                    WPSH_Notes: error,
                  }));
                }}
              ></SingleInputTextAreaNotesWPS>
            </Col>
          </Row>
        </Row>
        {/* -------------------------prepared by --------------------------------*/}
        <UnifiedSignatureSection
          sessionType="WPS"
          sectionType="prepared"
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          users={users}
          error={error}
          setError={setError}
          previewImage={previewuser}
          fetchUserProfile={fetchbyuserprofile}
          isReadonly={isReadonly}
          action={action}
          setIsEdited={setIsEdited}
          Band={Band}
          maxLength={50}
          todayDate={todayDate}
        />

        {/* -------------------------approved by --------------------------------*/}
        <UnifiedSignatureSection
          sessionType="WPS"
          sectionType="approved"
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          users={users}
          error={error}
          setError={setError}
          previewImage={previewapproved}
          fetchUserProfile={fetchapproveUserProfile}
          isReadonly={isReadonly}
          action={action}
          setIsEdited={setIsEdited}
          Band={Band}
          handleChangeRadio={handleChangeRadio}
          maxLength={280}
        />
      </Row>
    );
  }
);

export default WeldingProcedureSpec;
